export default "__VITE_ASSET__VxaofTLa__"